// eslint-disable-next-line @talend/import-depth
import { IconName } from '@talend/icons/dist/typeUtils';

export type DataAttributes = {
	'data-feature'?: string;
	'data-test'?: string;
	'data-testid'?: string;
};

export type DeprecatedIconNames = IconName;
